import manageJss from "@microsoft/fast-jss-manager-react";
import { Pane as BasePane, PaneResizeDirection, paneStyleSheet, } from "./pane";
/* tslint:disable-next-line:typedef */
const Pane = manageJss(paneStyleSheet)(BasePane);
export { Pane, PaneResizeDirection, };
